import { WebhookEventType } from '@/api/dashboard'

/**
 * Filters out campaign.custom and wildcard events (ending with '.*')
 * @param events - Array of webhook events to filter
 * @returns Filtered array of webhook events
 */
export const filterWebhookEvents = (events: WebhookEventType[]): WebhookEventType[] => {
  return events.filter(event => event !== 'campaign.custom' && !event.endsWith('.*'))
}
